// extracted by mini-css-extract-plugin
module.exports = {"modalFooter":"ModalFooter_modalFooter__3-E_h","modalFooterFlexLayout":"ModalFooter_modalFooterFlexLayout__2jItK"};